<template>
    <div class="see-map">    
        <div class="top">
            <div clang="left">视线裁判1</div>
            <div class="right">视线裁判2</div>
        </div>
        <div class="see" v-if="gameScoreData.length>0">
            <div class="left">
                <div class="box">
                    <div><span class="cell vertical-up">运动员<span class="num">{{gameScoreData[0].leftPlayerNum?gameScoreData[0].leftPlayerNum:0}}</span></span></div>
                    <div><span class="cell vertical-down">器械<span class="num">{{gameScoreData[0].leftWeaponNum?gameScoreData[0].leftWeaponNum:0}}</span></span></div>
                    <div><span class="cell level-left">运动员<span class="num">{{gameScoreData[0].bottomPlayerNum?gameScoreData[0].bottomPlayerNum:0}}</span></span></div>
                    <div><span class="cell level-right">器械<span class="num">{{gameScoreData[0].bottomWeaponNum?gameScoreData[0].bottomWeaponNum:0}}</span></span></div>
                </div>
            </div>
            <div class="right">
                  <div class="box">
                    <div><span class="cell vertical-up">运动员<span class="num">{{gameScoreData[1].rightPlayerNum?gameScoreData[1].rightPlayerNum:0}}</span></span></div>
                    <div><span class="cell vertical-down">器械<span class="num">{{gameScoreData[1].rightWeaponNum?gameScoreData[1].rightWeaponNum:0}}</span></span></div>
                    <div><span class="cell level-left">运动员<span class="num">{{gameScoreData[1].topPlayerNum?gameScoreData[1].topPlayerNum:0}}</span></span></div>
                    <div><span class="cell level-right">器械<span class="num">{{gameScoreData[1].topWeaponNum?gameScoreData[1].topWeaponNum:0}}</span></span></div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div clang="left">技术错误  -{{leftScore}}</div>
            <div class="right">技术错误  -{{rightScore}}</div>
        </div>
    </div>
</template>

<script>
export default {
  name:'GymsSeeMap',
  //   props:['gameScoreData'],
  props: {
    gameScoreData: {
      type: Array,
      default:()=>{
        return []
      }}
  },
  computed: {
    leftScore () {
      return parseFloat((this.gameScoreData[0].leftPlayerNum+this.gameScoreData[0].leftWeaponNum+this.gameScoreData[0].bottomPlayerNum+this.gameScoreData[0].bottomWeaponNum)*0.3).toFixed(2)
    },
    rightScore () {
      return parseFloat((this.gameScoreData[1].rightPlayerNum+this.gameScoreData[1].rightWeaponNum+this.gameScoreData[1].topPlayerNum+this.gameScoreData[1].topWeaponNum)*0.3).toFixed(2)
    },
  },
}
</script>

<style lang="scss" scoped>
.see-map{
     padding-left: 30px;
    .top,
    .bottom{
        padding-left: 15px;
        background-color: #DDDDDD;
        font-weight: bold;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        line-height: 50px;
          height: 50px;
        .left{
            width: 50%;       
        }
         .right{
            width: 50%;
        }
    }
    .see{
        display: flex;
        justify-content: space-between;
         .cell{
                display: inline-block;
                background-color: #DDDDDD;
                text-align: center;
                line-height: 30px;
                font-size: 14px;
                font-weight: bold;
        }
        //左边裁判
        .left{
            width: 50%;
            padding-left: 80px;
            margin-top: 20px;
            margin-bottom: 60px;
            .box{
                height: 200px;
                width: 200px;
                border-bottom: 2px solid #2364B9;
                border-left: 2px solid #2364B9;
                border-right: 2px solid #efefef;
                border-top: 2px solid #efefef;
                position: relative;
            }
            .vertical-up{
                width: 30px;
                height: 80px;
                writing-mode: vertical-lr;
                position: absolute;
                top:0;
                left: -40px;   
                .num{
                    writing-mode: horizontal-tb; 
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
            }
            .vertical-down{
                width: 30px;
                height: 80px;
                position: absolute;
                bottom:0;
                writing-mode: vertical-lr;
                left: -40px;
                .num{
                    writing-mode: horizontal-tb; 
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
            }

            .level-left{
                height: 30px;
                width: 80px;
                position: absolute;
                bottom:-40px;
                left:0;
                .num{
                    position: absolute;
                    bottom: -10px;
                    right: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
                
            }
            .level-right{
                height: 30px;
                width: 80px;
                position: absolute;
                bottom:-40px;
                right: 0;
                .num{
                    position: absolute;
                    bottom: -10px;
                    right: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }     
            }
        }
        //右边裁判
        .right{
            width: 50%;
            margin-top: 60px;
            margin-bottom:20px;
            .box{
                height: 200px;
                width: 200px;
                border-bottom: 2px solid #efefef;
                border-left: 2px solid #efefef;
                border-right: 2px solid #2364B9;
                border-top: 2px solid #2364B9;
                position: relative;
            }
               .vertical-up{
                width: 30px;
                height: 80px;
                writing-mode: vertical-lr;
                position: absolute;
                top:0;
                right: -40px;   
                .num{
                    writing-mode: horizontal-tb; 
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
            }
            .vertical-down{
                width: 30px;
                height: 80px;
                position: absolute;
                writing-mode: vertical-lr;
                bottom:0;
                right: -40px;  
                .num{
                    writing-mode: horizontal-tb; 
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
            }

            .level-left{
                height: 30px;
                width: 80px;
                position: absolute;
                top:-40px;
                left:0;
                .num{
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }
                
            }
            .level-right{
                height: 30px;
                width: 80px;
                position: absolute;
                margin-top:-40px;
                right: 0;
                .num{
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    background-color: #DDDDDD;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 10px;
                    box-shadow: 1px 1px 5px #FFFFFF;
                }     
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/gyms/GymsSeeMap.vue